import { PropTypes } from 'prop-types';
import { Button, Col, Form, Row, Select, Space } from 'antd';
import React from 'react';
import {
  CLINIC_PAYMENT_METHOD_ENUM_OPTIONS,
  getLastTenYears,
  MONTHS_WITH_ZERO_INDEX,
} from '../../../appContants';
import ClinicOwnersFormItem from '../../invoices/ClinicOwnersFormItem';

const InvoiceReportFilterForm = ({ onSubmit, onReset }) => {
  const [filterForm] = Form.useForm();

  const handleFormReset = () => {
    filterForm.resetFields();
    onReset?.();
  };

  return (
    <Form
      className="mb-3"
      form={filterForm}
      style={{ display: 'block' }}
      layout="vertical"
      onFinish={onSubmit}
    >
      {/* Collect invoiceType, monthNumber, yearNumber & doctorSub */}
      <Row gutter={16}>
        <Col md={8} lg={6} xl={6}>
          <Form.Item name="invoiceType" label="Invoice Type">
            <Select
              placeholder="Select invoice type"
              allowClear
              options={CLINIC_PAYMENT_METHOD_ENUM_OPTIONS}
            />
          </Form.Item>
        </Col>
        <Col md={8} lg={6} xl={6}>
          <Form.Item name="invoiceMonth" label="Month">
            <Select
              placeholder="Select Month"
              allowClear
              options={MONTHS_WITH_ZERO_INDEX}
            />
          </Form.Item>
        </Col>
        <Col md={8} lg={6} xl={6}>
          <Form.Item name="invoiceYear" label="Year">
            <Select
              placeholder="Select Year"
              allowClear
              options={getLastTenYears()}
            />
          </Form.Item>
        </Col>
        <Col md={8} lg={6} xl={6}>
          <Form.Item name="doctorSub" label="Clinic Location Owner">
            <ClinicOwnersFormItem />
          </Form.Item>
        </Col>
        <Col md={8} lg={6} xl={6}>
          <Form.Item noStyle>
            <Space align="center" style={{ height: '100%' }}>
              <Button type="primary" htmlType="submit">
                Filter
              </Button>
              <Button htmlType="button" onClick={handleFormReset}>
                Reset
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

InvoiceReportFilterForm.propTypes = {
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
};

export default InvoiceReportFilterForm;
